module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.customer_order")) + "\n                ")])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order_list"
  }, [_c('div', {
    staticClass: "col-main account_center"
  }, [_c('div', {
    staticClass: "std"
  }, [_c('div', {
    staticStyle: {
      "margin": "4px 0 0"
    }
  }, [_c('table', {
    staticClass: "edit_order",
    attrs: {
      "id": "my-orders-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "first last"
  }, [_c('th', [_vm._v(_vm._s(_vm.$t("message.order_increment_id")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("message.date")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("message.operate")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderList), function(item, index) {
    return _c('tr', {
      staticClass: "first odd"
    }, [_c('td', [_c('b', [_vm._v(_vm._s(item.increment_id))]), _c('br'), _vm._v(" "), _c('span', {
      class: 'order-status ' + item.order_status
    }, [_vm._v(_vm._s(item.order_status))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "nobr"
    }, [_vm._v(_vm._s(item.created_at))])]), _vm._v(" "), _c('td', {
      staticClass: "a-center last"
    }, [_c('span', {
      staticClass: "nobr"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.viewOrder(item.order_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("message.view_order")))]), _vm._v(" "), _c('span', {
      staticClass: "separator"
    }, [_vm._v("|")]), _vm._v(" "), _c('a', {
      staticClass: "link-reorder",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.reorder(item.order_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("message.reorder")))])])])])
  }), 0)]), _vm._v(" "), _c('mugen-scroll', {
    attrs: {
      "handler": _vm.fetchOrder,
      "should-handle": !_vm.loading,
      "scroll-container": "scrollContainer"
    }
  }, [_c('div', {
    staticClass: "infinite-scroll-preloader",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e7adeaf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Order.vue
// module id = 247
// module chunks = 1